import { operate1Monitor } from "../../assets/app-teaser-images/operate-1-monitor";
import { operate2Inspect } from "../../assets/app-teaser-images/operate-2-inspect";
import { operate3Troubleshoot } from "../../assets/app-teaser-images/operate-3-troubleshoot";
import { tasklist1TaskManager } from "../../assets/app-teaser-images/tasklist-1-task-manager";
import { tasklist2Form } from "../../assets/app-teaser-images/tasklist-2-form";
import { tasklist3Api } from "../../assets/app-teaser-images/tasklist-3-api";
import { optimize1Kpis } from "../../assets/app-teaser-images/optimize-1-Kpis";
import { optimize2Opportunities } from "../../assets/app-teaser-images/optimize-2-opportunities";
import { optimize3Reports } from "../../assets/app-teaser-images/optimize-3-reports";
const base64Src = (src) => `data:image/jpeg;base64,${src}`;
export const appTeaserCardsConfig = {
    operate: [
        {
            title: "Monitor processes",
            description: "Monitor the operational health of historic and current processes in a single place.",
            id: "operate-preview--monitor-process",
            img: {
                altText: "Operate app dashboard screenshot showing running process instances overview",
                path: base64Src(operate1Monitor),
            },
        },
        {
            title: "Drill down and inspect process instances",
            description: "Uncover process incidents or use visual cues paired with process models to find where instances are stuck.",
            id: "operate-preview-inspect-process",
            img: {
                altText: "Operate app screenshot showing process instance details",
                path: base64Src(operate2Inspect),
            },
        },
        {
            title: "Troubleshoot issues in near-real-time",
            description: "Before retrying instances and without losing any in-flight or historical data.",
            id: "operate-preview-troubleshoot",
            img: {
                altText: "Operate app screenshot showing process instance with incidents",
                path: base64Src(operate3Troubleshoot),
            },
        },
    ],
    tasklist: [
        {
            title: "User-friendly task manager",
            description: "Manage and run human tasks for full end-to-end orchestration with an user-friendly interface",
            id: "tasklist-preview-task-manager",
            img: {
                altText: "Tasklist app screenshot showing task overview",
                path: base64Src(tasklist1TaskManager),
            },
        },
        {
            title: "Create forms with just a few clicks",
            description: "Connect your teams by orchestrating human tasks and create forms with just a few clicks to help with it",
            id: "tasklist-preview-forms",
            img: {
                altText: "Modeler app screenshot showing form builder",
                path: base64Src(tasklist2Form),
            },
        },
        {
            title: "Use APIs to extend it",
            description: "Extend the manual workflows and tasklist by using with the Tasklist API",
            id: "tasklist-preview-api",
            img: {
                altText: "Camunda docs screenshot showing Tasklist API documentation",
                path: base64Src(tasklist3Api),
            },
        },
    ],
    optimize: [
        {
            title: "Monitor KPIs and get notified",
            description: "Monitor Process KPIs and get notified proactively about deviations",
            id: "optimize-preview-kpis",
            img: {
                altText: "Optimize app screenshot showing KPI monitoring dashboard",
                path: base64Src(optimize1Kpis),
            },
        },
        {
            title: "Find opportunities to improve",
            description: "Use analyses to find process improvements based on historic process executions",
            id: "optimize-preview-opportunities",
            img: {
                altText: "Optimize app screenshot showing process branch analysis",
                path: base64Src(optimize2Opportunities),
            },
        },
        {
            title: "Share reports and dashboards",
            description: "Share process intelligence reports & dashboards with every stakeholder",
            id: "optimize-preview-reports",
            img: {
                altText: "Optimize app screenshot showing process report heatmap",
                path: base64Src(optimize3Reports),
            },
        },
    ],
};
